import { PageLoader } from '@crehana/compass.ui/v3/page-loader';

// Dual duty: rendered by the page as the `loading` early return over
// `useConceptCatalog`, AND re-exported by the route's `loading.tsx` as
// Modern.js's own Suspense fallback while the route module loads — the second
// use case can mount before `useAddI18nLocales()` runs, so this stays
// i18n-free and relies on `PageLoader`'s own default (Spanish) label.
export const AdminConceptFormulaLoading = () => {
  return (
    <div className="tw-w-screen tw-h-screen">
      <PageLoader />
    </div>
  );
};
